import React, { useEffect, useState } from 'react';
import store from '../../store/bookerStore';
import { ReactComponent as InfoIcon } from '../../assets/img/payment-failed.svg';

const PaymentFailure = () => {
  const [isButtonDisplay, setIsButtonDisplay] = useState(false);
  const isStartedAsGuest = store.getState().isStartedAsGuest;

  useEffect(() => {
    setIsButtonDisplay(!checkIfIsIOSChrome() && isStartedAsGuest);

    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const clickHandler = () => {
    window.open('about:blank', '_self');
    window.close();
  };

  const checkIfIsIOSChrome = () => {
    const UA = navigator.userAgent;
    return /\b(iPad|iPhone|iPod)\b/.test(UA) && /CriOS/.test(UA); // check if it's Chrome on iOS;
  };

  return (
    <>
      <div className="failed-status-container">
        <p className="status-icon-container">
          <InfoIcon />
        </p>

        <h3>Payment Failure</h3>

        <p className="status-message">
          We will continue making attempts to charge your card. If we are not able to charge your card, Customer Support
          may contact you.
        </p>
      </div>
      {isButtonDisplay && (
        <div className="button-status-container">
          <button className="btn-primary" onClick={clickHandler}>
            Dismiss
          </button>
        </div>
      )}
    </>
  );
};

export default PaymentFailure;
